import React from 'react';
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import { Link, NavLink } from 'react-router-dom';
import { Assessment, CloudUpload, Search, Dashboard, Person } from '@mui/icons-material';
import { useAccount } from './Auth';
import { authService } from '../services/authService';

const Header = () => {
  const userEmail = useAccount()?.email;

  const handleLogout = async () => {
    await authService.logout();
    window.location.href = '/login';
  };

  return (
    <Navbar variant="light" expand="lg" className="bomwise-navbar mb-4">
      <Container>
        <Navbar.Brand as={Link} to="/">
          <Assessment className="me-2" />
          BOMWise
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={NavLink} to="/" end>
              <CloudUpload className="me-1" />
              Upload BOM
            </Nav.Link>
            <Nav.Link as={NavLink} to="/projects">
              <Dashboard className="me-1" />
              Projects
            </Nav.Link>
          </Nav>
          <Nav>
            {userEmail ? (
              <NavDropdown title={<><Person className="me-1" />{userEmail}</>} id="user-dropdown">
                <NavDropdown.Item onClick={handleLogout}>Logout</NavDropdown.Item>
              </NavDropdown>
            ) : (
              <Nav.Link as={NavLink} to="/login">
                <Person className="me-1" />
                Login
              </Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;